import React, { useState } from 'react';
import { Row, Col, Button, Table, Modal, Form } from 'react-bootstrap';
import { Get, Post, Put, DeleteSingle } from '../../../../utils/httpProvider';
import { HOPDONGCHITIET_API } from '../../../../utils/apiUrl';
import { toast } from 'react-toastify';
import { messageToast } from '../../../../utils/define';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';

const MaterialsAndTopicsTab = ({
    id,
    topicsData,
    isTopicsLoading,
    refetchTopics,
    materialsData,
    isMaterialsLoading,
    refetchMaterials
}) => {
    // Modal state for training documents
    const [showMaterialModal, setShowMaterialModal] = useState(false);
    const [editingMaterial, setEditingMaterial] = useState(null);

    // Modal state for detailed training program/topics
    const [showTopicModal, setShowTopicModal] = useState(false);
    const [editingTopic, setEditingTopic] = useState(null);

    // Delete Confirmation State
    const [idWantDelete, setIdWantDelete] = useState('');
    const [deleteType, setDeleteType] = useState(''); // 'material', 'topic'
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);

    // --- MATERIALS ACTIONS ---
    const handleOpenAddMaterial = () => {
        setEditingMaterial({ khoaHocId: id, tenTaiLieuDaoTao: '', documentLink: '' });
        setShowMaterialModal(true);
    };

    const handleOpenEditMaterial = (material) => {
        setEditingMaterial({
            ...material,
            tenTaiLieuDaoTao: material.tenTaiLieu || material.TenTaiLieu || material.tenTaiLieuDaoTao,
            documentLink: material.fileLink || material.FileLink || material.documentLink
        });
        setShowMaterialModal(true);
    };

    const handleSaveMaterial = async () => {
        const textVal = editingMaterial.tenTaiLieuDaoTao || editingMaterial.tenTaiLieu || editingMaterial.TenTaiLieu;
        if (!textVal) {
            toast.warning('Vui lòng nhập tên tài liệu.');
            return;
        }

        const payload = {
            id: editingMaterial.id || editingMaterial.Id,
            hopDongChiTietId: id,
            tenTaiLieu: textVal,
            fileLink: editingMaterial.documentLink || editingMaterial.fileLink || editingMaterial.FileLink
        };

        try {
            if (editingMaterial.id || editingMaterial.Id) {
                await Put(`${HOPDONGCHITIET_API.UPDATE_TAILIEU}`, editingMaterial.id || editingMaterial.Id, payload);
                toast.success(messageToast.messageToastUpdateSuccess);
            } else {
                await Post(`${HOPDONGCHITIET_API.ADD_TAILIEU}`, null, payload);
                toast.success(messageToast.messageToastCreateSuccess);
            }
            setShowMaterialModal(false);
            refetchMaterials();
        } catch (err) {
            toast.error(err?.message || 'Không thể lưu tài liệu.');
        }
    };

    const handleDeleteMaterial = (materialId) => {
        setIdWantDelete(materialId);
        setDeleteType('material');
        setConfirmDelMessage('Bạn có chắc chắn muốn xóa tài liệu dạy học này?');
        setOpenConfirmDeleteModal(true);
    };

    // --- TOPICS ACTIONS ---
    const handleOpenAddTopic = () => {
        setEditingTopic({ khoaHocId: id, tenChuongTrinhHoc: '', moTa: '', soTiet: 0 });
        setShowTopicModal(true);
    };

    const handleOpenEditTopic = (topic) => {
        setEditingTopic({
            ...topic,
            tenChuongTrinhHoc: topic.tenNoiDung || topic.TenNoiDung || topic.tenChuongTrinhHoc,
            moTa: topic.moTa || topic.MoTa,
            soTiet: topic.soTiet || topic.SoTiet || 0
        });
        setShowTopicModal(true);
    };

    const handleSaveTopic = async () => {
        const textVal = editingTopic.tenChuongTrinhHoc || editingTopic.tenNoiDung || editingTopic.TenNoiDung;
        if (!textVal) {
            toast.warning('Vui lòng nhập tên nội dung chương trình chi tiết.');
            return;
        }

        const payload = {
            id: editingTopic.id || editingTopic.Id,
            hopDongChiTietId: id,
            tenNoiDung: textVal,
            moTa: editingTopic.moTa,
            soTiet: Number(editingTopic.soTiet || 0)
        };

        try {
            if (editingTopic.id || editingTopic.Id) {
                await Put(`${HOPDONGCHITIET_API.UPDATE_CHUONGTRINH}`, editingTopic.id || editingTopic.Id, payload);
                toast.success(messageToast.messageToastUpdateSuccess);
            } else {
                await Post(`${HOPDONGCHITIET_API.ADD_CHUONGTRINH}`, null, payload);
                toast.success(messageToast.messageToastCreateSuccess);
            }
            setShowTopicModal(false);
            refetchTopics();
        } catch (err) {
            toast.error(err?.message || 'Không thể lưu chương trình.');
        }
    };

    const handleDeleteTopic = (topicId) => {
        setIdWantDelete(topicId);
        setDeleteType('topic');
        setConfirmDelMessage('Bạn có chắc chắn muốn xóa nội dung chương trình chi tiết này?');
        setOpenConfirmDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        if (!idWantDelete) return;

        try {
            if (deleteType === 'material') {
                await DeleteSingle(`${HOPDONGCHITIET_API.DELETE_TAILIEU}`, idWantDelete);
                toast.success(messageToast.messageToastDeleteSuccess);
                refetchMaterials();
            } else if (deleteType === 'topic') {
                await DeleteSingle(`${HOPDONGCHITIET_API.DELETE_CHUONGTRINH}`, idWantDelete);
                toast.success(messageToast.messageToastDeleteSuccess);
                refetchTopics();
            }
        } catch (err) {
            toast.error(err?.message || "Không thể thực hiện thao tác xóa.");
        } finally {
            setOpenConfirmDeleteModal(false);
            setIdWantDelete('');
            setDeleteType('');
        }
    };

    return (
        <>
            <Row className="mb-5">
                {/* CHƯƠNG TRÌNH ĐÀO TẠO CHI TIẾT */}
                <Col lg={6} className="pr-lg-4 mb-4 mb-lg-0">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-dark mb-0">
                            <i className="fas fa-list-ol mr-2 text-primary"></i>Chương trình thực hành chi tiết
                        </h5>
                        <Button variant="outline-primary" size="sm" onClick={handleOpenAddTopic} style={{ borderRadius: '6px' }}>
                            <i className="fas fa-plus mr-1"></i> Thêm nội dung
                        </Button>
                    </div>

                    {isTopicsLoading ? (
                        <div className="text-center py-4 text-muted"><div className="spinner-border spinner-border-sm text-primary mr-2"></div> Đang tải...</div>
                    ) : topicsData && topicsData.length > 0 ? (
                        <div className="table-responsive rounded border bg-white shadow-xs">
                            <Table hover size="sm" className="mb-0" style={{ fontSize: '0.85rem', verticalAlign: 'middle' }}>
                                <thead className="bg-light">
                                    <tr>
                                        <th className="text-center" style={{ width: '50px' }}>STT</th>
                                        <th>Tên nội dung thực hành</th>
                                        <th>Mô tả</th>
                                        <th>Số tiết</th>
                                        <th className="text-center" style={{ width: '90px' }}>Hành động</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {topicsData.map((t, idx) => (
                                        <tr key={t.id || t.Id}>
                                            <td className="text-center text-muted">{idx + 1}</td>
                                            <td>
                                                {t.tenNoiDung || t.TenNoiDung || t.tenChuongTrinhHoc || t.TenChuongTrinhHoc}
                                            </td>
                                            <td>{(t.moTa || t.MoTa)}</td>
                                            <td>{(t.soTiet)}</td>
                                            <td className="text-center">
                                                <Button variant="link" size="sm" className="p-1 mr-1 text-primary text-decoration-none" onClick={() => handleOpenEditTopic(t)}><i className="fas fa-edit"></i></Button>
                                                <Button variant="link" size="sm" className="p-1 text-danger text-decoration-none" onClick={() => handleDeleteTopic(t.id || t.Id)}><i className="fas fa-trash-alt"></i></Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="text-center py-4 text-muted bg-white border rounded small">Chương trình đào tạo chi tiết trống.</div>
                    )}
                </Col>

                {/* TÀI LIỆU DẠY VÀ HỌC */}
                <Col lg={6} className="pl-lg-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-dark mb-0">
                            <i className="fas fa-book mr-2 text-primary"></i>Tài liệu dạy và học
                        </h5>
                        <Button variant="outline-primary" size="sm" onClick={handleOpenAddMaterial} style={{ borderRadius: '6px' }}>
                            <i className="fas fa-plus mr-1"></i> Thêm tài liệu
                        </Button>
                    </div>

                    {isMaterialsLoading ? (
                        <div className="text-center py-4 text-muted"><div className="spinner-border spinner-border-sm text-primary mr-2"></div> Đang tải...</div>
                    ) : materialsData && materialsData.length > 0 ? (
                        <div className="table-responsive rounded border bg-white shadow-xs">
                            <Table hover size="sm" className="mb-0" style={{ fontSize: '0.85rem', verticalAlign: 'middle' }}>
                                <thead className="bg-light">
                                    <tr>
                                        <th className="text-center" style={{ width: '50px' }}>STT</th>
                                        <th>Tên tài liệu</th>
                                        <th>Đường dẫn / File</th>
                                        <th className="text-center" style={{ width: '90px' }}>Hành động</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {materialsData.map((m, idx) => (
                                        <tr key={m.id || m.Id}>
                                            <td className="text-center text-muted">{idx + 1}</td>
                                            <td className="font-weight-bold text-dark">{m.tenTaiLieu || m.TenTaiLieu || m.tenTaiLieuDaoTao || m.TenTaiLieuDaoTao}</td>
                                            <td>
                                                {m.fileLink || m.FileLink || m.documentLink || m.DocumentLink ? (
                                                    <a href={m.fileLink || m.FileLink || m.documentLink || m.DocumentLink} target="_blank" rel="noopener noreferrer" className="text-primary font-weight-bold small text-decoration-none">
                                                        <i className="fas fa-external-link-alt mr-1"></i>Xem tài liệu
                                                    </a>
                                                ) : (
                                                    <span className="text-muted small">Không có file đính kèm</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <Button variant="link" size="sm" className="p-1 mr-1 text-primary text-decoration-none" onClick={() => handleOpenEditMaterial(m)}><i className="fas fa-edit"></i></Button>
                                                <Button variant="link" size="sm" className="p-1 text-danger text-decoration-none" onClick={() => handleDeleteMaterial(m.id || m.Id)}><i className="fas fa-trash-alt"></i></Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="text-center py-4 text-muted bg-white border rounded small">Danh mục tài liệu trống.</div>
                    )}
                </Col>
            </Row>

            {/* EDIT MATERIAL MODAL */}
            {editingMaterial && (
                <Modal show={showMaterialModal} onHide={() => setShowMaterialModal(false)} centered>
                    <Modal.Header closeButton className="border-bottom-0 pb-0">
                        <Modal.Title className="font-weight-bold">
                            {editingMaterial.id || editingMaterial.Id ? 'Chỉnh sửa tài liệu học tập' : 'Thêm tài liệu học tập'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-2">
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small">Tên tài liệu <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ví dụ: Tài liệu hướng dẫn thực hành ngoại khoa..."
                                    value={editingMaterial.tenTaiLieuDaoTao || editingMaterial.TenTaiLieuDaoTao || ''}
                                    onChange={(e) => setEditingMaterial({
                                        ...editingMaterial,
                                        tenTaiLieuDaoTao: e.target.value,
                                        TenTaiLieuDaoTao: e.target.value
                                    })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small">Đường dẫn file (URL / Drive Link)</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="https://drive.google.com/..."
                                    value={editingMaterial.documentLink || editingMaterial.DocumentLink || ''}
                                    onChange={(e) => setEditingMaterial({
                                        ...editingMaterial,
                                        documentLink: e.target.value,
                                        DocumentLink: e.target.value
                                    })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="border-top-0 pt-0">
                        <Button variant="light" onClick={() => setShowMaterialModal(false)} style={{ borderRadius: '8px' }}>
                            Hủy bỏ
                        </Button>
                        <Button variant="primary" onClick={handleSaveMaterial} style={{ borderRadius: '8px' }}>
                            Lưu tài liệu
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* EDIT TOPIC MODAL */}
            {editingTopic && (
                <Modal show={showTopicModal} onHide={() => setShowTopicModal(false)} centered>
                    <Modal.Header closeButton className="border-bottom-0 pb-0">
                        <Modal.Title className="font-weight-bold">
                            {editingTopic.id || editingTopic.Id ? 'Chỉnh sửa nội dung thực hành' : 'Thêm nội dung thực hành'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-2">
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small">Tên nội dung thực hành <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ví dụ: Thực hành cấp cứu cơ bản..."
                                    value={editingTopic.tenChuongTrinhHoc || editingTopic.TenChuongTrinhHoc || ''}
                                    onChange={(e) => setEditingTopic({
                                        ...editingTopic,
                                        tenChuongTrinhHoc: e.target.value,
                                        TenChuongTrinhHoc: e.target.value
                                    })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small">Mô tả chi tiết</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Mô tả nội dung, chỉ tiêu thực hành..."
                                    value={editingTopic.moTa || editingTopic.MoTa || ''}
                                    onChange={(e) => setEditingTopic({
                                        ...editingTopic,
                                        moTa: e.target.value,
                                        MoTa: e.target.value
                                    })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small">Số tiết thực hành</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Số tiết..."
                                    value={editingTopic.soTiet || 0}
                                    onChange={(e) => setEditingTopic({
                                        ...editingTopic,
                                        soTiet: Number(e.target.value)
                                    })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="border-top-0 pt-0">
                        <Button variant="light" onClick={() => setShowTopicModal(false)} style={{ borderRadius: '8px' }}>
                            Hủy bỏ
                        </Button>
                        <Button variant="primary" onClick={handleSaveTopic} style={{ borderRadius: '8px' }}>
                            Lưu nội dung
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* DELETE CONFIRMATION MODAL */}
            <ConfirmModal
                show={openConfirmDeleteModal}
                onHide={() => setOpenConfirmDeleteModal(false)}
                onConfirm={handleConfirmDelete}
                message={confirmDelMessage}
            />
        </>
    );
};

export default MaterialsAndTopicsTab;
